<div [ngClass]="fieldItem.meta && fieldItem.meta.rowClasses"
    id="{{id}}"
    [attr.data-rowid]="fieldItem.field.id || fieldItem.field.fieldKey"
    (click)="fieldItemOnClick(fieldItem)">
    <div [ngClass]="fieldItem.meta && fieldItem.meta.columnClasses" class="map-val d-flex align-items-center" style="--i: {{fieldItem.level ? fieldItem.level : 2}}">
        <div *ngIf="fieldItem?.meta?.ifs?.deleteLine"  class="visibleline">
            <span *ngIf="fieldItem?.meta?.ifs?.lines?.length < 2" (click)="onAddDataTransformation(fieldItem.meta && fieldItem.meta.ifs.line)" class="correspondence-status" [ngClass]="fieldItem.meta && fieldItem.meta.transformationClasses" tooltip="{{fieldItem.meta.hasTransformation ? (fieldItem.meta.readableTransformation | translate) : ('Add modifiers' | translate)}}" placement="right"></span>
            <many-to-one-handler *ngIf="fieldItem?.meta?.ifs?.lines?.length >= 2" [lines]="fieldItem?.meta?.ifs?.lines" (deleteLine)="deleteSelectionChild($event)" (choosenLine)="onAddDataTransformation($event)" [transformationClass]="fieldItem.meta && fieldItem.meta.transformationClasses"></many-to-one-handler>
            <span class="correspondence-line"></span>
            <i (click)="deleteSelectionChild(fieldItem.meta && fieldItem.meta.ifs.line.lineId)"
                class="removeline fal fa-times btn-xs btn-bordered btn-icon flow-remove-icon"></i>
            <i *ngIf="fieldItem.meta.ifs.notfullCatalogMapped"
                tooltip="{{'Both value and key fields must be mapped' | translate}}"
                placement="right"
                class="catalogWarning fas fa-bolt btn-xs btn-bordered btn-icon flow-remove-icon"></i>
        </div>
        <div class="hiddenline"></div>
        <div class="field-icon field-icon-tree text-muted no-bg mr-2"></div>
        <i [ngClass]="fieldItem.meta && fieldItem.meta.fieldClasses" class="field-icon" tooltip="{{fieldItem.field.type}}"></i>
        <span class="field-item-title">
            <ng-container *ngIf="fieldItem.meta && fieldItem.meta.texts && fieldItem.meta.texts.name">
                <ng-container *ngIf="translatableFields.includes(fieldItem.meta.texts.name)">
                    <span [innerHTML]="fieldItem.meta.texts.name | translate"></span>
                </ng-container>
                <ng-container *ngIf="!translatableFields.includes(fieldItem.meta.texts.name)">
                    <span [innerHTML]="fieldItem.meta.texts.name"></span>
                </ng-container>
            </ng-container>
        </span>
        <!--<i [ngClass]="fieldItem.meta && fieldItem.meta.childEyeClasses" class="far ml-auto cursor-pointer field-item-visibility"
            (click)="showHideField.emit(fieldItem.field)"></i>-->
    </div>
</div>
